export enum RecordingFile {
    Microphone = 1,
    Sensor = 2,
}
